<template>
    <div class="shows-list box">
        <base-listing-handler
            v-if="shows"
            key="shows-listing"
            v-slot:default="{
                filteredItems,
                pageLimit,
                itemsCount,
                totalPages,
                sortOptions,
                sortBy,
                isReverse,
                controlsChange,
                paginationShowNav,
                setPageNumber,
                pageNum,
            }"
            :items="shows"
            :sort-options="sortListOptions"
            :paginate="true"
        >
            <div class="box-title">
                Shows in Your Plan
                <base-search-input
                    placeholder="Search show..."
                    @input="value => controlsChange({ searchPhrase: value })"
                />
            </div>
            <shows-listing
                layout="list"
                :items="filteredItems"
                :sort-options="sortOptions"
                :sort-by="sortBy"
                :is-reverse="isReverse"
                :has-pro-shows="hasProShows"
                :hide-labels="true"
                @change="value => controlsChange(value)"
                @remove-show="openDeleteShowModal"
            />
            <div class="box-content">
                <base-submit-button
                    class="btn add-btn"
                    @click="onCreateShow"
                >
                    Add New Show
                </base-submit-button>
                <paginate
                    v-if="itemsCount > pageLimit"
                    :page-count="totalPages"
                    :click-handler="setPageNumber"
                    :prev-text="''"
                    :next-text="''"
                    :class="[{ 'has-navigation': paginationShowNav } ,'pagination']"
                    :active-class="'is-active'"
                    :prev-link-class="'pagination-arrow pagination-prev'"
                    :next-link-class="'pagination-arrow pagination-next'"
                    :hide-prev-next="paginationShowNav"
                    :first-last-button="paginationShowNav"
                    :first-button-text="''"
                    :last-button-text="''"
                    :break-view-class="'pagination-decorator'"
                    :value="pageNum"
                />
            </div>
        </base-listing-handler>
    </div>
</template>

<script>
import ShowsListing from '@/components/Shows/ShowsListing';
import Paginate from 'vuejs-paginate';
import {
    mapActions,
    mapState,
    mapMutations,
} from 'vuex';
import { ACTION } from '@/components/ShowModal/config';

export default {
    components: {
        ShowsListing,
        Paginate,
    },

    data: () => ({
        sortListOptions: [
            {
                label: 'Show',
                listLabel: 'Show',
                value: 'title',
            },
        ],
        hasProShows: false,
    }),

    computed: {
        ...mapState(['shows']),
    },

    methods: {
        ...mapActions('show/modal', {
            openShowModal: 'openModal',
        }),

        ...mapMutations('show/modal', {
            setShowModalAction: 'setAction',
        }),

        ...mapMutations(['changeUIState']),

        /**
         * Handles create show action.
         */
        onCreateShow() {
            this.setShowModalAction(ACTION.CREATE);
            this.openShowModal();
        },

        /**
         * Sets show to be deleted info and opens modal
         *
         * @param   {object}  data  Show info
         *
         */
        openDeleteShowModal(data) {
            this.changeUIState({
                deleteShowModal: {
                    ...data,
                    visible: true,
                },
            });
        },
    },
};
</script>
